import React from 'react';
import { Wrench, Shield, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const TroisExpertises = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="deux-expertises" className="py-24 bg-white">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-[#FF6600] font-semibold text-sm uppercase tracking-wider">
            Nos activités
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mt-3 mb-4">
            Trois expertises au service de votre activité industrielle
          </h2>
        </div>

        {/* Grid 3 colonnes */}
        <div className="grid lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          
          {/* Bloc 1 : Équipements de quai */}
          <div className="bg-gradient-to-br from-blue-50 to-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow p-10 border border-blue-100">
            <div className="flex items-center justify-center w-20 h-20 bg-blue-600 rounded-full mb-6 mx-auto">
              <Shield className="w-10 h-10 text-white" />
            </div>
            <h3 className="text-2xl font-bold text-slate-900 mb-4 text-center">
              Équipements de quai & Sécurité industrielle
            </h3>
            <p className="text-gray-700 text-center mb-8 leading-relaxed">
              Nous équipons, rénovons et sécurisons vos zones de chargement et de déchargement : 
              ponts de quai, niveleurs, butoirs, garde-corps, barrières et protections adaptées 
              à vos installations.
            </p>
            <div className="text-center">
              <Button 
                onClick={() => scrollToSection('products')}
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 group"
              >
                Découvrir nos équipements
                <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </Button>
            </div>
          </div>

          {/* Bloc 2 : Maintenance des quais */}
          <div className="bg-gradient-to-br from-orange-50 to-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow p-10 border border-orange-100">
            <div className="flex items-center justify-center w-20 h-20 bg-orange-600 rounded-full mb-6 mx-auto">
              <Wrench className="w-10 h-10 text-white" />
            </div>
            <h3 className="text-2xl font-bold text-slate-900 mb-4 text-center">
              Maintenance des équipements de quai
            </h3>
            <p className="text-gray-700 text-center mb-8 leading-relaxed">
              Entretien, révision et réparation de niveleurs de quai, portes sectionnelles et rideaux métalliques. 
              Contrats d'entretien et dépannage rapide.
            </p>
            <div className="text-center">
              <a href="/maintenance-quai">
                <Button 
                  className="bg-orange-600 hover:bg-orange-700 text-white px-6 py-3 group"
                >
                  Nos offres de maintenance
                  <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </Button>
              </a>
            </div>
          </div>

          {/* Bloc 3 : Maintenance industrielle & Soudage */}
          <div className="bg-gradient-to-br from-purple-50 to-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow p-10 border border-purple-100">
            <div className="flex items-center justify-center w-20 h-20 bg-purple-600 rounded-full mb-6 mx-auto">
              <Wrench className="w-10 h-10 text-white" />
            </div>
            <h3 className="text-2xl font-bold text-slate-900 mb-4 text-center">
              Maintenance industrielle & Soudage
            </h3>
            <p className="text-gray-700 text-center mb-8 leading-relaxed">
              Maintenance préventive et curative d'installations industrielles. Soudage et réparation métallique 
              sur site avec poste autonome.
            </p>
            <div className="text-center">
              <a href="/maintenance-sav">
                <Button 
                  className="bg-purple-600 hover:bg-purple-700 text-white px-6 py-3 group"
                >
                  Découvrir ces prestations
                  <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </Button>
              </a>
            </div>
          </div>
          
        </div>

        {/* Bottom Note */}
        <div className="mt-12 text-center max-w-3xl mx-auto">
          <p className="text-gray-600 text-lg">
            <strong className="text-slate-900">Sécuriser • Équiper • Fiabiliser</strong>
            <br/>
            Trois métiers complémentaires pour des installations industrielles sûres et opérationnelles.
          </p>
        </div>
      </div>
    </section>
  );
};

export default TroisExpertises;
